import { render } from "./QuizLeaderboard.vue?vue&type=template&id=fabcf06a"
import script from "./QuizLeaderboard.vue?vue&type=script&lang=js"
export * from "./QuizLeaderboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__